import React, { useState } from 'react'
import useOutsideClick from 'hooks/useOutsideClick'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import wrapField from '../shared/wrapField'
import defaultColors from './pickerColors'

import ColorTile from './ColorTile'
import ColorControllers from './ColorControllers'

import {
	StyledColoredButton,
	StyledPicker,
	StyledTriangle
} from './styled'

const ColorPicker = (props) => {
	const { fieldState = {}, withColorControllers = true } = props
	const [isOpen, setIsOpen] = useState(false)
	const togglePicker = () => {
		setIsOpen(prevState => !prevState)
	}
	const [t] = useTranslation()

	const [containerRef] = useOutsideClick(() => {
		if (isOpen) {
			togglePicker()
		}
	})

	const selectColor = color => {
		const { smartSubmit, noForm, fieldApi, onChange } = props
		const newColor = color === '#' ? null : color
		if (!noForm) {
			fieldApi.setValue(newColor)
		}
		if (onChange) {
			onChange(color)
		}
		if (smartSubmit) {
			smartSubmit.submit()
		}
	}


	const value = fieldState.value || props.value
	const colorsInRow = 8

	const pickerHeight = withColorControllers ?
		Math.floor(defaultColors.length / colorsInRow) * 40 + 20 + 85 :
		Math.floor(defaultColors.length / colorsInRow) * 40 + 20

	return(
		<div ref={containerRef}>
			<StyledColoredButton
				backgroundColor={value}
				onClick={togglePicker}
			>
				{!value ? t('common.strings.color_missed') : ''}
			</StyledColoredButton>
			{isOpen &&
			<StyledPicker
				width={colorsInRow * 38 + 40}
				height={pickerHeight}
			>
				<StyledTriangle />
				{defaultColors.map((color, i) => (
					<ColorTile key={i} color={color} selectColor={selectColor} togglePicker={togglePicker}/>
				))}
				{withColorControllers &&
				<ColorControllers togglePicker={togglePicker} selectColor={selectColor} formColor={value}/>
				}
			</StyledPicker>
			}
		</div>
	)
}

ColorPicker.propTypes = {
	field: PropTypes.string,
	fieldApi: PropTypes.object,
	withColorControllers: PropTypes.bool,
	onChange: PropTypes.func
}

export default wrapField(ColorPicker)
